import { useTranslation } from 'react-i18next';

import SocialMediaCard from '~/components/Social/SocialMediaCard';
import {
  TssSocialIcon,
  TswSocialIcon
} from '~/components/Social/SocialMediaIcon';

const SocialSection = () => {
  const { t } = useTranslation('pdp');

  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-title-sm">{t('joinTheCommunity')}</h2>
      <div className="flex flex-wrap justify-center gap-2 md:gap-6">
        <SocialMediaCard
          className="min-w-[156px] flex-1 xs:min-w-[180px] md:min-w-[456px]"
          group="tss"
          icon={<TssSocialIcon />}
        />
        <SocialMediaCard
          className="min-w-[156px] flex-1 xs:min-w-[180px] md:min-w-[456px]"
          group="tsw"
          icon={<TswSocialIcon />}
        />
      </div>
    </div>
  );
};

export default SocialSection;
